const compatModules = {};import * as Mod1 from "./discourse/admin-discourse-ai-plugin-route-map";
compatModules["discourse/admin-discourse-ai-plugin-route-map"] = Mod1;

export * as discourse$admin__discourse__ai__plugin__route__map$$__module from "./discourse/admin-discourse-ai-plugin-route-map";
export {
default as discourse$admin__discourse__ai__plugin__route__map$$default
} from "./discourse/admin-discourse-ai-plugin-route-map";
import * as Mod2 from "./discourse/admin-discourse-ai-route-map";
compatModules["discourse/admin-discourse-ai-route-map"] = Mod2;

export * as discourse$admin__discourse__ai__route__map$$__module from "./discourse/admin-discourse-ai-route-map";
export {
default as discourse$admin__discourse__ai__route__map$$default
} from "./discourse/admin-discourse-ai-route-map";
import * as Mod3 from "./discourse/admin/adapters/ai-agent";
compatModules["discourse/admin/adapters/ai-agent"] = Mod3;

export * as discourse$admin$adapters$ai__agent$$__module from "./discourse/admin/adapters/ai-agent";
export {
default as discourse$admin$adapters$ai__agent$$default
} from "./discourse/admin/adapters/ai-agent";
import * as Mod4 from "./discourse/admin/adapters/ai-embedding";
compatModules["discourse/admin/adapters/ai-embedding"] = Mod4;

export * as discourse$admin$adapters$ai__embedding$$__module from "./discourse/admin/adapters/ai-embedding";
export {
default as discourse$admin$adapters$ai__embedding$$default
} from "./discourse/admin/adapters/ai-embedding";
import * as Mod5 from "./discourse/admin/adapters/ai-feature";
compatModules["discourse/admin/adapters/ai-feature"] = Mod5;

export * as discourse$admin$adapters$ai__feature$$__module from "./discourse/admin/adapters/ai-feature";
export {
default as discourse$admin$adapters$ai__feature$$default
} from "./discourse/admin/adapters/ai-feature";
import * as Mod6 from "./discourse/admin/adapters/ai-llm";
compatModules["discourse/admin/adapters/ai-llm"] = Mod6;

export * as discourse$admin$adapters$ai__llm$$__module from "./discourse/admin/adapters/ai-llm";
export {
default as discourse$admin$adapters$ai__llm$$default
} from "./discourse/admin/adapters/ai-llm";
import * as Mod7 from "./discourse/admin/adapters/ai-mcp-server";
compatModules["discourse/admin/adapters/ai-mcp-server"] = Mod7;

export * as discourse$admin$adapters$ai__mcp__server$$__module from "./discourse/admin/adapters/ai-mcp-server";
export {
default as discourse$admin$adapters$ai__mcp__server$$default
} from "./discourse/admin/adapters/ai-mcp-server";
import * as Mod8 from "./discourse/admin/adapters/ai-secret";
compatModules["discourse/admin/adapters/ai-secret"] = Mod8;

export * as discourse$admin$adapters$ai__secret$$__module from "./discourse/admin/adapters/ai-secret";
export {
default as discourse$admin$adapters$ai__secret$$default
} from "./discourse/admin/adapters/ai-secret";
import * as Mod9 from "./discourse/admin/adapters/ai-tool";
compatModules["discourse/admin/adapters/ai-tool"] = Mod9;

export * as discourse$admin$adapters$ai__tool$$__module from "./discourse/admin/adapters/ai-tool";
export {
default as discourse$admin$adapters$ai__tool$$default
} from "./discourse/admin/adapters/ai-tool";
import * as Mod10 from "./discourse/admin/models/ai-agent";
compatModules["discourse/admin/models/ai-agent"] = Mod10;

export * as discourse$admin$models$ai__agent$$__module from "./discourse/admin/models/ai-agent";
export {
default as discourse$admin$models$ai__agent$$default
} from "./discourse/admin/models/ai-agent";
import * as Mod11 from "./discourse/admin/models/ai-embedding";
compatModules["discourse/admin/models/ai-embedding"] = Mod11;

export * as discourse$admin$models$ai__embedding$$__module from "./discourse/admin/models/ai-embedding";
export {
default as discourse$admin$models$ai__embedding$$default
} from "./discourse/admin/models/ai-embedding";
import * as Mod12 from "./discourse/admin/models/ai-feature";
compatModules["discourse/admin/models/ai-feature"] = Mod12;

export * as discourse$admin$models$ai__feature$$__module from "./discourse/admin/models/ai-feature";
export {
default as discourse$admin$models$ai__feature$$default
} from "./discourse/admin/models/ai-feature";
import * as Mod13 from "./discourse/admin/models/ai-llm";
compatModules["discourse/admin/models/ai-llm"] = Mod13;

export * as discourse$admin$models$ai__llm$$__module from "./discourse/admin/models/ai-llm";
export {
default as discourse$admin$models$ai__llm$$default
} from "./discourse/admin/models/ai-llm";
import * as Mod14 from "./discourse/admin/models/ai-mcp-server";
compatModules["discourse/admin/models/ai-mcp-server"] = Mod14;

export * as discourse$admin$models$ai__mcp__server$$__module from "./discourse/admin/models/ai-mcp-server";
export {
default as discourse$admin$models$ai__mcp__server$$default
} from "./discourse/admin/models/ai-mcp-server";
import * as Mod15 from "./discourse/admin/models/ai-secret";
compatModules["discourse/admin/models/ai-secret"] = Mod15;

export * as discourse$admin$models$ai__secret$$__module from "./discourse/admin/models/ai-secret";
export {
default as discourse$admin$models$ai__secret$$default
} from "./discourse/admin/models/ai-secret";
import * as Mod16 from "./discourse/admin/models/ai-tool";
compatModules["discourse/admin/models/ai-tool"] = Mod16;

export * as discourse$admin$models$ai__tool$$__module from "./discourse/admin/models/ai-tool";
export {
default as discourse$admin$models$ai__tool$$default
} from "./discourse/admin/models/ai-tool";
import * as Mod17 from "./discourse/components/admin-report-emotion";
compatModules["discourse/components/admin-report-emotion"] = Mod17;

export * as discourse$components$admin__report__emotion$$__module from "./discourse/components/admin-report-emotion";
export {
default as discourse$components$admin__report__emotion$$default
} from "./discourse/components/admin-report-emotion";
import * as Mod18 from "./discourse/components/ai-agent-example";
compatModules["discourse/components/ai-agent-example"] = Mod18;

export * as discourse$components$ai__agent__example$$__module from "./discourse/components/ai-agent-example";
export {
default as discourse$components$ai__agent__example$$default
} from "./discourse/components/ai-agent-example";
import * as Mod19 from "./discourse/components/ai-agent-llm-selector";
compatModules["discourse/components/ai-agent-llm-selector"] = Mod19;

export * as discourse$components$ai__agent__llm__selector$$__module from "./discourse/components/ai-agent-llm-selector";
export {
default as discourse$components$ai__agent__llm__selector$$default
} from "./discourse/components/ai-agent-llm-selector";
import * as Mod20 from "./discourse/components/ai-agent-tool-options";
compatModules["discourse/components/ai-agent-tool-options"] = Mod20;

export * as discourse$components$ai__agent__tool__options$$__module from "./discourse/components/ai-agent-tool-options";
export {
default as discourse$components$ai__agent__tool__options$$default
} from "./discourse/components/ai-agent-tool-options";
import * as Mod21 from "./discourse/components/ai-artifact";
compatModules["discourse/components/ai-artifact"] = Mod21;

export * as discourse$components$ai__artifact$$__module from "./discourse/components/ai-artifact";
export {
default as discourse$components$ai__artifact$$default
} from "./discourse/components/ai-artifact";
import * as Mod22 from "./discourse/components/ai-blinking-animation";
compatModules["discourse/components/ai-blinking-animation"] = Mod22;

export * as discourse$components$ai__blinking__animation$$__module from "./discourse/components/ai-blinking-animation";
export {
default as discourse$components$ai__blinking__animation$$default
} from "./discourse/components/ai-blinking-animation";
import * as Mod23 from "./discourse/components/ai-bot-chats-tab";
compatModules["discourse/components/ai-bot-chats-tab"] = Mod23;

export * as discourse$components$ai__bot__chats__tab$$__module from "./discourse/components/ai-bot-chats-tab";
export {
default as discourse$components$ai__bot__chats__tab$$default
} from "./discourse/components/ai-bot-chats-tab";
import * as Mod24 from "./discourse/components/ai-bot-conversations";
compatModules["discourse/components/ai-bot-conversations"] = Mod24;

export * as discourse$components$ai__bot__conversations$$__module from "./discourse/components/ai-bot-conversations";
export {
default as discourse$components$ai__bot__conversations$$default
} from "./discourse/components/ai-bot-conversations";
import * as Mod25 from "./discourse/components/ai-bot-docked-composer";
compatModules["discourse/components/ai-bot-docked-composer"] = Mod25;

export * as discourse$components$ai__bot__docked__composer$$__module from "./discourse/components/ai-bot-docked-composer";
export {
default as discourse$components$ai__bot__docked__composer$$default
} from "./discourse/components/ai-bot-docked-composer";
import * as Mod26 from "./discourse/components/ai-bot-header-icon";
compatModules["discourse/components/ai-bot-header-icon"] = Mod26;

export * as discourse$components$ai__bot__header__icon$$__module from "./discourse/components/ai-bot-header-icon";
export {
default as discourse$components$ai__bot__header__icon$$default
} from "./discourse/components/ai-bot-header-icon";
import * as Mod27 from "./discourse/components/ai-bot-sidebar-empty-state";
compatModules["discourse/components/ai-bot-sidebar-empty-state"] = Mod27;

export * as discourse$components$ai__bot__sidebar__empty__state$$__module from "./discourse/components/ai-bot-sidebar-empty-state";
export {
default as discourse$components$ai__bot__sidebar__empty__state$$default
} from "./discourse/components/ai-bot-sidebar-empty-state";
import * as Mod28 from "./discourse/components/ai-bot-sidebar-new-conversation";
compatModules["discourse/components/ai-bot-sidebar-new-conversation"] = Mod28;

export * as discourse$components$ai__bot__sidebar__new__conversation$$__module from "./discourse/components/ai-bot-sidebar-new-conversation";
export {
default as discourse$components$ai__bot__sidebar__new__conversation$$default
} from "./discourse/components/ai-bot-sidebar-new-conversation";
import * as Mod29 from "./discourse/components/ai-composer-helper-menu";
compatModules["discourse/components/ai-composer-helper-menu"] = Mod29;

export * as discourse$components$ai__composer__helper__menu$$__module from "./discourse/components/ai-composer-helper-menu";
export {
default as discourse$components$ai__composer__helper__menu$$default
} from "./discourse/components/ai-composer-helper-menu";
import * as Mod30 from "./discourse/components/ai-conversation-sidebar-context-menu";
compatModules["discourse/components/ai-conversation-sidebar-context-menu"] = Mod30;

export * as discourse$components$ai__conversation__sidebar__context__menu$$__module from "./discourse/components/ai-conversation-sidebar-context-menu";
export {
default as discourse$components$ai__conversation__sidebar__context__menu$$default
} from "./discourse/components/ai-conversation-sidebar-context-menu";
import * as Mod31 from "./discourse/components/ai-credit-bar";
compatModules["discourse/components/ai-credit-bar"] = Mod31;

export * as discourse$components$ai__credit__bar$$__module from "./discourse/components/ai-credit-bar";
export {
default as discourse$components$ai__credit__bar$$default
} from "./discourse/components/ai-credit-bar";
import * as Mod32 from "./discourse/components/ai-feature-card";
compatModules["discourse/components/ai-feature-card"] = Mod32;

export * as discourse$components$ai__feature__card$$__module from "./discourse/components/ai-feature-card";
export {
default as discourse$components$ai__feature__card$$default
} from "./discourse/components/ai-feature-card";
import * as Mod33 from "./discourse/components/ai-features-list";
compatModules["discourse/components/ai-features-list"] = Mod33;

export * as discourse$components$ai__features__list$$__module from "./discourse/components/ai-features-list";
export {
default as discourse$components$ai__features__list$$default
} from "./discourse/components/ai-features-list";
import * as Mod34 from "./discourse/components/ai-full-page-search";
compatModules["discourse/components/ai-full-page-search"] = Mod34;

export * as discourse$components$ai__full__page__search$$__module from "./discourse/components/ai-full-page-search";
export {
default as discourse$components$ai__full__page__search$$default
} from "./discourse/components/ai-full-page-search";
import * as Mod35 from "./discourse/components/ai-gist-toggle";
compatModules["discourse/components/ai-gist-toggle"] = Mod35;

export * as discourse$components$ai__gist__toggle$$__module from "./discourse/components/ai-gist-toggle";
export {
default as discourse$components$ai__gist__toggle$$default
} from "./discourse/components/ai-gist-toggle";
import * as Mod36 from "./discourse/components/ai-helper-custom-prompt";
compatModules["discourse/components/ai-helper-custom-prompt"] = Mod36;

export * as discourse$components$ai__helper__custom__prompt$$__module from "./discourse/components/ai-helper-custom-prompt";
export {
default as discourse$components$ai__helper__custom__prompt$$default
} from "./discourse/components/ai-helper-custom-prompt";
import * as Mod37 from "./discourse/components/ai-helper-loading";
compatModules["discourse/components/ai-helper-loading"] = Mod37;

export * as discourse$components$ai__helper__loading$$__module from "./discourse/components/ai-helper-loading";
export {
default as discourse$components$ai__helper__loading$$default
} from "./discourse/components/ai-helper-loading";
import * as Mod38 from "./discourse/components/ai-helper-options-list";
compatModules["discourse/components/ai-helper-options-list"] = Mod38;

export * as discourse$components$ai__helper__options__list$$__module from "./discourse/components/ai-helper-options-list";
export {
default as discourse$components$ai__helper__options__list$$default
} from "./discourse/components/ai-helper-options-list";
import * as Mod39 from "./discourse/components/ai-indicator-wave";
compatModules["discourse/components/ai-indicator-wave"] = Mod39;

export * as discourse$components$ai__indicator__wave$$__module from "./discourse/components/ai-indicator-wave";
export {
default as discourse$components$ai__indicator__wave$$default
} from "./discourse/components/ai-indicator-wave";
import * as Mod40 from "./discourse/components/ai-llm-attachment-types";
compatModules["discourse/components/ai-llm-attachment-types"] = Mod40;

export * as discourse$components$ai__llm__attachment__types$$__module from "./discourse/components/ai-llm-attachment-types";
export {
default as discourse$components$ai__llm__attachment__types$$default
} from "./discourse/components/ai-llm-attachment-types";
import * as Mod41 from "./discourse/components/ai-llm-selector";
compatModules["discourse/components/ai-llm-selector"] = Mod41;

export * as discourse$components$ai__llm__selector$$__module from "./discourse/components/ai-llm-selector";
export {
default as discourse$components$ai__llm__selector$$default
} from "./discourse/components/ai-llm-selector";
import * as Mod42 from "./discourse/components/ai-mcp-server-editor-form";
compatModules["discourse/components/ai-mcp-server-editor-form"] = Mod42;

export * as discourse$components$ai__mcp__server__editor__form$$__module from "./discourse/components/ai-mcp-server-editor-form";
export {
default as discourse$components$ai__mcp__server__editor__form$$default
} from "./discourse/components/ai-mcp-server-editor-form";
import * as Mod43 from "./discourse/components/ai-mcp-server-editor";
compatModules["discourse/components/ai-mcp-server-editor"] = Mod43;

export * as discourse$components$ai__mcp__server__editor$$__module from "./discourse/components/ai-mcp-server-editor";
export {
default as discourse$components$ai__mcp__server__editor$$default
} from "./discourse/components/ai-mcp-server-editor";
import * as Mod44 from "./discourse/components/ai-post-helper-menu";
compatModules["discourse/components/ai-post-helper-menu"] = Mod44;

export * as discourse$components$ai__post__helper__menu$$__module from "./discourse/components/ai-post-helper-menu";
export {
default as discourse$components$ai__post__helper__menu$$default
} from "./discourse/components/ai-post-helper-menu";
import * as Mod45 from "./discourse/components/ai-quota-duration-selector";
compatModules["discourse/components/ai-quota-duration-selector"] = Mod45;

export * as discourse$components$ai__quota__duration__selector$$__module from "./discourse/components/ai-quota-duration-selector";
export {
default as discourse$components$ai__quota__duration__selector$$default
} from "./discourse/components/ai-quota-duration-selector";
import * as Mod46 from "./discourse/components/ai-regen-summaries-buttons";
compatModules["discourse/components/ai-regen-summaries-buttons"] = Mod46;

export * as discourse$components$ai__regen__summaries__buttons$$__module from "./discourse/components/ai-regen-summaries-buttons";
export {
default as discourse$components$ai__regen__summaries__buttons$$default
} from "./discourse/components/ai-regen-summaries-buttons";
import * as Mod47 from "./discourse/components/ai-search-discoveries-tooltip";
compatModules["discourse/components/ai-search-discoveries-tooltip"] = Mod47;

export * as discourse$components$ai__search__discoveries__tooltip$$__module from "./discourse/components/ai-search-discoveries-tooltip";
export {
default as discourse$components$ai__search__discoveries__tooltip$$default
} from "./discourse/components/ai-search-discoveries-tooltip";
import * as Mod48 from "./discourse/components/ai-search-discoveries";
compatModules["discourse/components/ai-search-discoveries"] = Mod48;

export * as discourse$components$ai__search__discoveries$$__module from "./discourse/components/ai-search-discoveries";
export {
default as discourse$components$ai__search__discoveries$$default
} from "./discourse/components/ai-search-discoveries";
import * as Mod49 from "./discourse/components/ai-secret-editor-form";
compatModules["discourse/components/ai-secret-editor-form"] = Mod49;

export * as discourse$components$ai__secret__editor__form$$__module from "./discourse/components/ai-secret-editor-form";
export {
default as discourse$components$ai__secret__editor__form$$default
} from "./discourse/components/ai-secret-editor-form";
import * as Mod50 from "./discourse/components/ai-secret-selector";
compatModules["discourse/components/ai-secret-selector"] = Mod50;

export * as discourse$components$ai__secret__selector$$__module from "./discourse/components/ai-secret-selector";
export {
default as discourse$components$ai__secret__selector$$default
} from "./discourse/components/ai-secret-selector";
import * as Mod51 from "./discourse/components/ai-sentiment-horizontal-bar";
compatModules["discourse/components/ai-sentiment-horizontal-bar"] = Mod51;

export * as discourse$components$ai__sentiment__horizontal__bar$$__module from "./discourse/components/ai-sentiment-horizontal-bar";
export {
default as discourse$components$ai__sentiment__horizontal__bar$$default
} from "./discourse/components/ai-sentiment-horizontal-bar";
import * as Mod52 from "./discourse/components/ai-split-topic-suggester";
compatModules["discourse/components/ai-split-topic-suggester"] = Mod52;

export * as discourse$components$ai__split__topic__suggester$$__module from "./discourse/components/ai-split-topic-suggester";
export {
default as discourse$components$ai__split__topic__suggester$$default
} from "./discourse/components/ai-split-topic-suggester";
import * as Mod53 from "./discourse/components/ai-summary-skeleton";
compatModules["discourse/components/ai-summary-skeleton"] = Mod53;

export * as discourse$components$ai__summary__skeleton$$__module from "./discourse/components/ai-summary-skeleton";
export {
default as discourse$components$ai__summary__skeleton$$default
} from "./discourse/components/ai-summary-skeleton";
import * as Mod54 from "./discourse/components/ai-tool-editor-form";
compatModules["discourse/components/ai-tool-editor-form"] = Mod54;

export * as discourse$components$ai__tool__editor__form$$__module from "./discourse/components/ai-tool-editor-form";
export {
default as discourse$components$ai__tool__editor__form$$default
} from "./discourse/components/ai-tool-editor-form";
import * as Mod55 from "./discourse/components/ai-tool-editor";
compatModules["discourse/components/ai-tool-editor"] = Mod55;

export * as discourse$components$ai__tool__editor$$__module from "./discourse/components/ai-tool-editor";
export {
default as discourse$components$ai__tool__editor$$default
} from "./discourse/components/ai-tool-editor";
import * as Mod56 from "./discourse/components/ai-tool-selector";
compatModules["discourse/components/ai-tool-selector"] = Mod56;

export * as discourse$components$ai__tool__selector$$__module from "./discourse/components/ai-tool-selector";
export {
default as discourse$components$ai__tool__selector$$default
} from "./discourse/components/ai-tool-selector";
import * as Mod57 from "./discourse/components/ai-topic-gist";
compatModules["discourse/components/ai-topic-gist"] = Mod57;

export * as discourse$components$ai__topic__gist$$__module from "./discourse/components/ai-topic-gist";
export {
default as discourse$components$ai__topic__gist$$default
} from "./discourse/components/ai-topic-gist";
import * as Mod58 from "./discourse/components/bulk-actions/ai-regen-summaries";
compatModules["discourse/components/bulk-actions/ai-regen-summaries"] = Mod58;

export * as discourse$components$bulk__actions$ai__regen__summaries$$__module from "./discourse/components/bulk-actions/ai-regen-summaries";
export {
default as discourse$components$bulk__actions$ai__regen__summaries$$default
} from "./discourse/components/bulk-actions/ai-regen-summaries";
import * as Mod59 from "./discourse/components/modal/ai-agent-mcp-tool-selector-modal";
compatModules["discourse/components/modal/ai-agent-mcp-tool-selector-modal"] = Mod59;

export * as discourse$components$modal$ai__agent__mcp__tool__selector__modal$$__module from "./discourse/components/modal/ai-agent-mcp-tool-selector-modal";
export {
default as discourse$components$modal$ai__agent__mcp__tool__selector__modal$$default
} from "./discourse/components/modal/ai-agent-mcp-tool-selector-modal";
import * as Mod60 from "./discourse/components/modal/ai-agent-response-format-editor";
compatModules["discourse/components/modal/ai-agent-response-format-editor"] = Mod60;

export * as discourse$components$modal$ai__agent__response__format__editor$$__module from "./discourse/components/modal/ai-agent-response-format-editor";
export {
default as discourse$components$modal$ai__agent__response__format__editor$$default
} from "./discourse/components/modal/ai-agent-response-format-editor";
import * as Mod61 from "./discourse/components/modal/ai-llm-quota-modal";
compatModules["discourse/components/modal/ai-llm-quota-modal"] = Mod61;

export * as discourse$components$modal$ai__llm__quota__modal$$__module from "./discourse/components/modal/ai-llm-quota-modal";
export {
default as discourse$components$modal$ai__llm__quota__modal$$default
} from "./discourse/components/modal/ai-llm-quota-modal";
import * as Mod62 from "./discourse/components/modal/ai-mcp-server-tools-modal";
compatModules["discourse/components/modal/ai-mcp-server-tools-modal"] = Mod62;

export * as discourse$components$modal$ai__mcp__server__tools__modal$$__module from "./discourse/components/modal/ai-mcp-server-tools-modal";
export {
default as discourse$components$modal$ai__mcp__server__tools__modal$$default
} from "./discourse/components/modal/ai-mcp-server-tools-modal";
import * as Mod63 from "./discourse/components/modal/ai-regen-summaries-modal";
compatModules["discourse/components/modal/ai-regen-summaries-modal"] = Mod63;

export * as discourse$components$modal$ai__regen__summaries__modal$$__module from "./discourse/components/modal/ai-regen-summaries-modal";
export {
default as discourse$components$modal$ai__regen__summaries__modal$$default
} from "./discourse/components/modal/ai-regen-summaries-modal";
import * as Mod64 from "./discourse/components/modal/ai-secret-create-modal";
compatModules["discourse/components/modal/ai-secret-create-modal"] = Mod64;

export * as discourse$components$modal$ai__secret__create__modal$$__module from "./discourse/components/modal/ai-secret-create-modal";
export {
default as discourse$components$modal$ai__secret__create__modal$$default
} from "./discourse/components/modal/ai-secret-create-modal";
import * as Mod65 from "./discourse/components/modal/ai-summary-modal";
compatModules["discourse/components/modal/ai-summary-modal"] = Mod65;

export * as discourse$components$modal$ai__summary__modal$$__module from "./discourse/components/modal/ai-summary-modal";
export {
default as discourse$components$modal$ai__summary__modal$$default
} from "./discourse/components/modal/ai-summary-modal";
import * as Mod66 from "./discourse/components/modal/ai-tool-test-modal";
compatModules["discourse/components/modal/ai-tool-test-modal"] = Mod66;

export * as discourse$components$modal$ai__tool__test__modal$$__module from "./discourse/components/modal/ai-tool-test-modal";
export {
default as discourse$components$modal$ai__tool__test__modal$$default
} from "./discourse/components/modal/ai-tool-test-modal";
import * as Mod67 from "./discourse/components/modal/chat-modal-channel-summary";
compatModules["discourse/components/modal/chat-modal-channel-summary"] = Mod67;

export * as discourse$components$modal$chat__modal__channel__summary$$__module from "./discourse/components/modal/chat-modal-channel-summary";
export {
default as discourse$components$modal$chat__modal__channel__summary$$default
} from "./discourse/components/modal/chat-modal-channel-summary";
import * as Mod68 from "./discourse/components/modal/debug-ai-modal";
compatModules["discourse/components/modal/debug-ai-modal"] = Mod68;

export * as discourse$components$modal$debug__ai__modal$$__module from "./discourse/components/modal/debug-ai-modal";
export {
default as discourse$components$modal$debug__ai__modal$$default
} from "./discourse/components/modal/debug-ai-modal";
import * as Mod69 from "./discourse/components/modal/diff-modal";
compatModules["discourse/components/modal/diff-modal"] = Mod69;

export * as discourse$components$modal$diff__modal$$__module from "./discourse/components/modal/diff-modal";
export {
default as discourse$components$modal$diff__modal$$default
} from "./discourse/components/modal/diff-modal";
import * as Mod70 from "./discourse/components/modal/share-full-topic-modal";
compatModules["discourse/components/modal/share-full-topic-modal"] = Mod70;

export * as discourse$components$modal$share__full__topic__modal$$__module from "./discourse/components/modal/share-full-topic-modal";
export {
default as discourse$components$modal$share__full__topic__modal$$default
} from "./discourse/components/modal/share-full-topic-modal";
import * as Mod71 from "./discourse/components/modal/share-modal";
compatModules["discourse/components/modal/share-modal"] = Mod71;

export * as discourse$components$modal$share__modal$$__module from "./discourse/components/modal/share-modal";
export {
default as discourse$components$modal$share__modal$$default
} from "./discourse/components/modal/share-modal";
import * as Mod72 from "./discourse/components/modal/spam-test-modal";
compatModules["discourse/components/modal/spam-test-modal"] = Mod72;

export * as discourse$components$modal$spam__test__modal$$__module from "./discourse/components/modal/spam-test-modal";
export {
default as discourse$components$modal$spam__test__modal$$default
} from "./discourse/components/modal/spam-test-modal";
import * as Mod73 from "./discourse/components/modal/thumbnail-suggestions";
compatModules["discourse/components/modal/thumbnail-suggestions"] = Mod73;

export * as discourse$components$modal$thumbnail__suggestions$$__module from "./discourse/components/modal/thumbnail-suggestions";
export {
default as discourse$components$modal$thumbnail__suggestions$$default
} from "./discourse/components/modal/thumbnail-suggestions";
import * as Mod74 from "./discourse/components/model-accuracies";
compatModules["discourse/components/model-accuracies"] = Mod74;

export * as discourse$components$model__accuracies$$__module from "./discourse/components/model-accuracies";
export {
default as discourse$components$model__accuracies$$default
} from "./discourse/components/model-accuracies";
import * as Mod75 from "./discourse/components/post-menu/ai-cancel-streaming-button";
compatModules["discourse/components/post-menu/ai-cancel-streaming-button"] = Mod75;

export * as discourse$components$post__menu$ai__cancel__streaming__button$$__module from "./discourse/components/post-menu/ai-cancel-streaming-button";
export {
default as discourse$components$post__menu$ai__cancel__streaming__button$$default
} from "./discourse/components/post-menu/ai-cancel-streaming-button";
import * as Mod76 from "./discourse/components/post-menu/ai-debug-button";
compatModules["discourse/components/post-menu/ai-debug-button"] = Mod76;

export * as discourse$components$post__menu$ai__debug__button$$__module from "./discourse/components/post-menu/ai-debug-button";
export {
default as discourse$components$post__menu$ai__debug__button$$default
} from "./discourse/components/post-menu/ai-debug-button";
import * as Mod77 from "./discourse/components/post-menu/ai-retry-streaming-button";
compatModules["discourse/components/post-menu/ai-retry-streaming-button"] = Mod77;

export * as discourse$components$post__menu$ai__retry__streaming__button$$__module from "./discourse/components/post-menu/ai-retry-streaming-button";
export {
default as discourse$components$post__menu$ai__retry__streaming__button$$default
} from "./discourse/components/post-menu/ai-retry-streaming-button";
import * as Mod78 from "./discourse/components/post-menu/ai-share-button";
compatModules["discourse/components/post-menu/ai-share-button"] = Mod78;

export * as discourse$components$post__menu$ai__share__button$$__module from "./discourse/components/post-menu/ai-share-button";
export {
default as discourse$components$post__menu$ai__share__button$$default
} from "./discourse/components/post-menu/ai-share-button";
import * as Mod79 from "./discourse/components/post/ai-agent-flair";
compatModules["discourse/components/post/ai-agent-flair"] = Mod79;

export * as discourse$components$post$ai__agent__flair$$__module from "./discourse/components/post/ai-agent-flair";
export {
default as discourse$components$post$ai__agent__flair$$default
} from "./discourse/components/post/ai-agent-flair";
import * as Mod80 from "./discourse/components/post/meta-data/ai-cancel-streaming";
compatModules["discourse/components/post/meta-data/ai-cancel-streaming"] = Mod80;

export * as discourse$components$post$meta__data$ai__cancel__streaming$$__module from "./discourse/components/post/meta-data/ai-cancel-streaming";
export {
default as discourse$components$post$meta__data$ai__cancel__streaming$$default
} from "./discourse/components/post/meta-data/ai-cancel-streaming";
import * as Mod81 from "./discourse/components/rag-options-fk";
compatModules["discourse/components/rag-options-fk"] = Mod81;

export * as discourse$components$rag__options__fk$$__module from "./discourse/components/rag-options-fk";
export {
default as discourse$components$rag__options__fk$$default
} from "./discourse/components/rag-options-fk";
import * as Mod82 from "./discourse/components/rag-upload-progress";
compatModules["discourse/components/rag-upload-progress"] = Mod82;

export * as discourse$components$rag__upload__progress$$__module from "./discourse/components/rag-upload-progress";
export {
default as discourse$components$rag__upload__progress$$default
} from "./discourse/components/rag-upload-progress";
import * as Mod83 from "./discourse/components/rag-uploader";
compatModules["discourse/components/rag-uploader"] = Mod83;

export * as discourse$components$rag__uploader$$__module from "./discourse/components/rag-uploader";
export {
default as discourse$components$rag__uploader$$default
} from "./discourse/components/rag-uploader";
import * as Mod84 from "./discourse/components/reviewable/ai-chat-message";
compatModules["discourse/components/reviewable/ai-chat-message"] = Mod84;

export * as discourse$components$reviewable$ai__chat__message$$__module from "./discourse/components/reviewable/ai-chat-message";
export {
default as discourse$components$reviewable$ai__chat__message$$default
} from "./discourse/components/reviewable/ai-chat-message";
import * as Mod85 from "./discourse/components/reviewable/ai-post";
compatModules["discourse/components/reviewable/ai-post"] = Mod85;

export * as discourse$components$reviewable$ai__post$$__module from "./discourse/components/reviewable/ai-post";
export {
default as discourse$components$reviewable$ai__post$$default
} from "./discourse/components/reviewable/ai-post";
import * as Mod86 from "./discourse/components/reviewable/ai-tool-action";
compatModules["discourse/components/reviewable/ai-tool-action"] = Mod86;

export * as discourse$components$reviewable$ai__tool__action$$__module from "./discourse/components/reviewable/ai-tool-action";
export {
default as discourse$components$reviewable$ai__tool__action$$default
} from "./discourse/components/reviewable/ai-tool-action";
import * as Mod87 from "./discourse/components/suggestion-menus/ai-category-suggester";
compatModules["discourse/components/suggestion-menus/ai-category-suggester"] = Mod87;

export * as discourse$components$suggestion__menus$ai__category__suggester$$__module from "./discourse/components/suggestion-menus/ai-category-suggester";
export {
default as discourse$components$suggestion__menus$ai__category__suggester$$default
} from "./discourse/components/suggestion-menus/ai-category-suggester";
import * as Mod88 from "./discourse/components/suggestion-menus/ai-tag-suggester";
compatModules["discourse/components/suggestion-menus/ai-tag-suggester"] = Mod88;

export * as discourse$components$suggestion__menus$ai__tag__suggester$$__module from "./discourse/components/suggestion-menus/ai-tag-suggester";
export {
default as discourse$components$suggestion__menus$ai__tag__suggester$$default
} from "./discourse/components/suggestion-menus/ai-tag-suggester";
import * as Mod89 from "./discourse/components/suggestion-menus/ai-title-suggester";
compatModules["discourse/components/suggestion-menus/ai-title-suggester"] = Mod89;

export * as discourse$components$suggestion__menus$ai__title__suggester$$__module from "./discourse/components/suggestion-menus/ai-title-suggester";
export {
default as discourse$components$suggestion__menus$ai__title__suggester$$default
} from "./discourse/components/suggestion-menus/ai-title-suggester";
import * as Mod90 from "./discourse/components/thumbnail-suggestion-item";
compatModules["discourse/components/thumbnail-suggestion-item"] = Mod90;

export * as discourse$components$thumbnail__suggestion__item$$__module from "./discourse/components/thumbnail-suggestion-item";
export {
default as discourse$components$thumbnail__suggestion__item$$default
} from "./discourse/components/thumbnail-suggestion-item";
import * as Mod91 from "./discourse/connectors/admin-customize-theme-translation-selector/ai-theme-translate.gjs";
compatModules["discourse/connectors/admin-customize-theme-translation-selector/ai-theme-translate"] = Mod91;

export * as discourse$connectors$admin__customize__theme__translation__selector$ai__theme__translate$$__module from "./discourse/connectors/admin-customize-theme-translation-selector/ai-theme-translate.gjs";
export {
default as discourse$connectors$admin__customize__theme__translation__selector$ai__theme__translate$$default
} from "./discourse/connectors/admin-customize-theme-translation-selector/ai-theme-translate.gjs";
import * as Mod92 from "./discourse/connectors/admin-dashboard-highlights-before-kpis/ai-admin-dashboard-highlight.gjs";
compatModules["discourse/connectors/admin-dashboard-highlights-before-kpis/ai-admin-dashboard-highlight"] = Mod92;

export * as discourse$connectors$admin__dashboard__highlights__before__kpis$ai__admin__dashboard__highlight$$__module from "./discourse/connectors/admin-dashboard-highlights-before-kpis/ai-admin-dashboard-highlight.gjs";
export {
default as discourse$connectors$admin__dashboard__highlights__before__kpis$ai__admin__dashboard__highlight$$default
} from "./discourse/connectors/admin-dashboard-highlights-before-kpis/ai-admin-dashboard-highlight.gjs";
import * as Mod93 from "./discourse/connectors/admin-dashboard-tabs-after/admin-sentiment-dashbboard.gjs";
compatModules["discourse/connectors/admin-dashboard-tabs-after/admin-sentiment-dashbboard"] = Mod93;

export * as discourse$connectors$admin__dashboard__tabs__after$admin__sentiment__dashbboard$$__module from "./discourse/connectors/admin-dashboard-tabs-after/admin-sentiment-dashbboard.gjs";
export {
default as discourse$connectors$admin__dashboard__tabs__after$admin__sentiment__dashbboard$$default
} from "./discourse/connectors/admin-dashboard-tabs-after/admin-sentiment-dashbboard.gjs";
import * as Mod94 from "./discourse/connectors/after-composer-title-input/ai-title-suggestion.gjs";
compatModules["discourse/connectors/after-composer-title-input/ai-title-suggestion"] = Mod94;

export * as discourse$connectors$after__composer__title__input$ai__title__suggestion$$__module from "./discourse/connectors/after-composer-title-input/ai-title-suggestion.gjs";
export {
default as discourse$connectors$after__composer__title__input$ai__title__suggestion$$default
} from "./discourse/connectors/after-composer-title-input/ai-title-suggestion.gjs";
import * as Mod95 from "./discourse/connectors/after-d-editor/composer-open.gjs";
compatModules["discourse/connectors/after-d-editor/composer-open"] = Mod95;

export * as discourse$connectors$after__d__editor$composer__open$$__module from "./discourse/connectors/after-d-editor/composer-open.gjs";
export {
default as discourse$connectors$after__d__editor$composer__open$$default
} from "./discourse/connectors/after-d-editor/composer-open.gjs";
import * as Mod96 from "./discourse/connectors/after-filter-navigation-menu/filter-gist-toggle.gjs";
compatModules["discourse/connectors/after-filter-navigation-menu/filter-gist-toggle"] = Mod96;

export * as discourse$connectors$after__filter__navigation__menu$filter__gist__toggle$$__module from "./discourse/connectors/after-filter-navigation-menu/filter-gist-toggle.gjs";
export {
default as discourse$connectors$after__filter__navigation__menu$filter__gist__toggle$$default
} from "./discourse/connectors/after-filter-navigation-menu/filter-gist-toggle.gjs";
import * as Mod97 from "./discourse/connectors/after-search-result-entry/search-result-decoration.gjs";
compatModules["discourse/connectors/after-search-result-entry/search-result-decoration"] = Mod97;

export * as discourse$connectors$after__search__result__entry$search__result__decoration$$__module from "./discourse/connectors/after-search-result-entry/search-result-decoration.gjs";
export {
default as discourse$connectors$after__search__result__entry$search__result__decoration$$default
} from "./discourse/connectors/after-search-result-entry/search-result-decoration.gjs";
import * as Mod98 from "./discourse/connectors/before-create-topic-button/topic-list-gist-toggle.gjs";
compatModules["discourse/connectors/before-create-topic-button/topic-list-gist-toggle"] = Mod98;

export * as discourse$connectors$before__create__topic__button$topic__list__gist__toggle$$__module from "./discourse/connectors/before-create-topic-button/topic-list-gist-toggle.gjs";
export {
default as discourse$connectors$before__create__topic__button$topic__list__gist__toggle$$default
} from "./discourse/connectors/before-create-topic-button/topic-list-gist-toggle.gjs";
import * as Mod99 from "./discourse/connectors/composer-fields/agent-llm-selector.gjs";
compatModules["discourse/connectors/composer-fields/agent-llm-selector"] = Mod99;

export * as discourse$connectors$composer__fields$agent__llm__selector$$__module from "./discourse/connectors/composer-fields/agent-llm-selector.gjs";
export {
default as discourse$connectors$composer__fields$agent__llm__selector$$default
} from "./discourse/connectors/composer-fields/agent-llm-selector.gjs";
import * as Mod100 from "./discourse/connectors/edit-topic-category__after/ai-category-suggestion.gjs";
compatModules["discourse/connectors/edit-topic-category__after/ai-category-suggestion"] = Mod100;

export * as discourse$connectors$edit__topic__category__after$ai__category__suggestion$$__module from "./discourse/connectors/edit-topic-category__after/ai-category-suggestion.gjs";
export {
default as discourse$connectors$edit__topic__category__after$ai__category__suggestion$$default
} from "./discourse/connectors/edit-topic-category__after/ai-category-suggestion.gjs";
import * as Mod101 from "./discourse/connectors/edit-topic-tags__after/ai-tag-suggestion.gjs";
compatModules["discourse/connectors/edit-topic-tags__after/ai-tag-suggestion"] = Mod101;

export * as discourse$connectors$edit__topic__tags__after$ai__tag__suggestion$$__module from "./discourse/connectors/edit-topic-tags__after/ai-tag-suggestion.gjs";
export {
default as discourse$connectors$edit__topic__tags__after$ai__tag__suggestion$$default
} from "./discourse/connectors/edit-topic-tags__after/ai-tag-suggestion.gjs";
import * as Mod102 from "./discourse/connectors/edit-topic-title__after/ai-title-suggestion.gjs";
compatModules["discourse/connectors/edit-topic-title__after/ai-title-suggestion"] = Mod102;

export * as discourse$connectors$edit__topic__title__after$ai__title__suggestion$$__module from "./discourse/connectors/edit-topic-title__after/ai-title-suggestion.gjs";
export {
default as discourse$connectors$edit__topic__title__after$ai__title__suggestion$$default
} from "./discourse/connectors/edit-topic-title__after/ai-title-suggestion.gjs";
import * as Mod103 from "./discourse/connectors/editor-preview/ai-image-caption-container.gjs";
compatModules["discourse/connectors/editor-preview/ai-image-caption-container"] = Mod103;

export * as discourse$connectors$editor__preview$ai__image__caption__container$$__module from "./discourse/connectors/editor-preview/ai-image-caption-container.gjs";
export {
default as discourse$connectors$editor__preview$ai__image__caption__container$$default
} from "./discourse/connectors/editor-preview/ai-image-caption-container.gjs";
import * as Mod104 from "./discourse/connectors/fast-edit-footer-after/ai-edit-suggestion-button.gjs";
compatModules["discourse/connectors/fast-edit-footer-after/ai-edit-suggestion-button"] = Mod104;

export * as discourse$connectors$fast__edit__footer__after$ai__edit__suggestion__button$$__module from "./discourse/connectors/fast-edit-footer-after/ai-edit-suggestion-button.gjs";
export {
default as discourse$connectors$fast__edit__footer__after$ai__edit__suggestion__button$$default
} from "./discourse/connectors/fast-edit-footer-after/ai-edit-suggestion-button.gjs";
import * as Mod105 from "./discourse/connectors/full-page-search-advanced-header/ai-full-page-search.gjs";
compatModules["discourse/connectors/full-page-search-advanced-header/ai-full-page-search"] = Mod105;

export * as discourse$connectors$full__page__search__advanced__header$ai__full__page__search$$__module from "./discourse/connectors/full-page-search-advanced-header/ai-full-page-search.gjs";
export {
default as discourse$connectors$full__page__search__advanced__header$ai__full__page__search$$default
} from "./discourse/connectors/full-page-search-advanced-header/ai-full-page-search.gjs";
import * as Mod106 from "./discourse/connectors/full-page-search-before-results/ai-search-results-notice.gjs";
compatModules["discourse/connectors/full-page-search-before-results/ai-search-results-notice"] = Mod106;

export * as discourse$connectors$full__page__search__before__results$ai__search__results__notice$$__module from "./discourse/connectors/full-page-search-before-results/ai-search-results-notice.gjs";
export {
default as discourse$connectors$full__page__search__before__results$ai__search__results__notice$$default
} from "./discourse/connectors/full-page-search-before-results/ai-search-results-notice.gjs";
import * as Mod107 from "./discourse/connectors/full-page-search-below-search-header/ai-full-page-discobot-discoveries.gjs";
compatModules["discourse/connectors/full-page-search-below-search-header/ai-full-page-discobot-discoveries"] = Mod107;

export * as discourse$connectors$full__page__search__below__search__header$ai__full__page__discobot__discoveries$$__module from "./discourse/connectors/full-page-search-below-search-header/ai-full-page-discobot-discoveries.gjs";
export {
default as discourse$connectors$full__page__search__below__search__header$ai__full__page__discobot__discoveries$$default
} from "./discourse/connectors/full-page-search-below-search-header/ai-full-page-discobot-discoveries.gjs";
import * as Mod108 from "./discourse/connectors/post-menu-translations-dropdown/ai-post-menu-translation-extras.gjs";
compatModules["discourse/connectors/post-menu-translations-dropdown/ai-post-menu-translation-extras"] = Mod108;

export * as discourse$connectors$post__menu__translations__dropdown$ai__post__menu__translation__extras$$__module from "./discourse/connectors/post-menu-translations-dropdown/ai-post-menu-translation-extras.gjs";
export {
default as discourse$connectors$post__menu__translations__dropdown$ai__post__menu__translation__extras$$default
} from "./discourse/connectors/post-menu-translations-dropdown/ai-post-menu-translation-extras.gjs";
import * as Mod109 from "./discourse/connectors/post-text-buttons/ai-post-helper-trigger.gjs";
compatModules["discourse/connectors/post-text-buttons/ai-post-helper-trigger"] = Mod109;

export * as discourse$connectors$post__text__buttons$ai__post__helper__trigger$$__module from "./discourse/connectors/post-text-buttons/ai-post-helper-trigger.gjs";
export {
default as discourse$connectors$post__text__buttons$ai__post__helper__trigger$$default
} from "./discourse/connectors/post-text-buttons/ai-post-helper-trigger.gjs";
import * as Mod110 from "./discourse/connectors/search-menu-before-advanced-search/ai-quick-search-loader.gjs";
compatModules["discourse/connectors/search-menu-before-advanced-search/ai-quick-search-loader"] = Mod110;

export * as discourse$connectors$search__menu__before__advanced__search$ai__quick__search__loader$$__module from "./discourse/connectors/search-menu-before-advanced-search/ai-quick-search-loader.gjs";
export {
default as discourse$connectors$search__menu__before__advanced__search$ai__quick__search__loader$$default
} from "./discourse/connectors/search-menu-before-advanced-search/ai-quick-search-loader.gjs";
import * as Mod111 from "./discourse/connectors/search-menu-results-bottom/ai-quick-search.gjs";
compatModules["discourse/connectors/search-menu-results-bottom/ai-quick-search"] = Mod111;

export * as discourse$connectors$search__menu__results__bottom$ai__quick__search$$__module from "./discourse/connectors/search-menu-results-bottom/ai-quick-search.gjs";
export {
default as discourse$connectors$search__menu__results__bottom$ai__quick__search$$default
} from "./discourse/connectors/search-menu-results-bottom/ai-quick-search.gjs";
import * as Mod112 from "./discourse/connectors/search-menu-results-top/ai-discobot-discoveries.gjs";
compatModules["discourse/connectors/search-menu-results-top/ai-discobot-discoveries"] = Mod112;

export * as discourse$connectors$search__menu__results__top$ai__discobot__discoveries$$__module from "./discourse/connectors/search-menu-results-top/ai-discobot-discoveries.gjs";
export {
default as discourse$connectors$search__menu__results__top$ai__discobot__discoveries$$default
} from "./discourse/connectors/search-menu-results-top/ai-discobot-discoveries.gjs";
import * as Mod113 from "./discourse/connectors/search-menu-results-top/ai-quick-search-info.gjs";
compatModules["discourse/connectors/search-menu-results-top/ai-quick-search-info"] = Mod113;

export * as discourse$connectors$search__menu__results__top$ai__quick__search__info$$__module from "./discourse/connectors/search-menu-results-top/ai-quick-search-info.gjs";
export {
default as discourse$connectors$search__menu__results__top$ai__quick__search__info$$default
} from "./discourse/connectors/search-menu-results-top/ai-quick-search-info.gjs";
import * as Mod114 from "./discourse/connectors/search-menu-results-type-top/ai-quick-search-notice.gjs";
compatModules["discourse/connectors/search-menu-results-type-top/ai-quick-search-notice"] = Mod114;

export * as discourse$connectors$search__menu__results__type__top$ai__quick__search__notice$$__module from "./discourse/connectors/search-menu-results-type-top/ai-quick-search-notice.gjs";
export {
default as discourse$connectors$search__menu__results__type__top$ai__quick__search__notice$$default
} from "./discourse/connectors/search-menu-results-type-top/ai-quick-search-notice.gjs";
import * as Mod115 from "./discourse/connectors/split-new-topic-category-after/ai-category-suggestion.gjs";
compatModules["discourse/connectors/split-new-topic-category-after/ai-category-suggestion"] = Mod115;

export * as discourse$connectors$split__new__topic__category__after$ai__category__suggestion$$__module from "./discourse/connectors/split-new-topic-category-after/ai-category-suggestion.gjs";
export {
default as discourse$connectors$split__new__topic__category__after$ai__category__suggestion$$default
} from "./discourse/connectors/split-new-topic-category-after/ai-category-suggestion.gjs";
import * as Mod116 from "./discourse/connectors/split-new-topic-tag-after/ai-tag-suggestion.gjs";
compatModules["discourse/connectors/split-new-topic-tag-after/ai-tag-suggestion"] = Mod116;

export * as discourse$connectors$split__new__topic__tag__after$ai__tag__suggestion$$__module from "./discourse/connectors/split-new-topic-tag-after/ai-tag-suggestion.gjs";
export {
default as discourse$connectors$split__new__topic__tag__after$ai__tag__suggestion$$default
} from "./discourse/connectors/split-new-topic-tag-after/ai-tag-suggestion.gjs";
import * as Mod117 from "./discourse/connectors/split-new-topic-title-after/ai-title-suggestion.gjs";
compatModules["discourse/connectors/split-new-topic-title-after/ai-title-suggestion"] = Mod117;

export * as discourse$connectors$split__new__topic__title__after$ai__title__suggestion$$__module from "./discourse/connectors/split-new-topic-title-after/ai-title-suggestion.gjs";
export {
default as discourse$connectors$split__new__topic__title__after$ai__title__suggestion$$default
} from "./discourse/connectors/split-new-topic-title-after/ai-title-suggestion.gjs";
import * as Mod118 from "./discourse/connectors/topic-map-expanded-after/ai-summary-trigger.gjs";
compatModules["discourse/connectors/topic-map-expanded-after/ai-summary-trigger"] = Mod118;

export * as discourse$connectors$topic__map__expanded__after$ai__summary__trigger$$__module from "./discourse/connectors/topic-map-expanded-after/ai-summary-trigger.gjs";
export {
default as discourse$connectors$topic__map__expanded__after$ai__summary__trigger$$default
} from "./discourse/connectors/topic-map-expanded-after/ai-summary-trigger.gjs";
import * as Mod119 from "./discourse/connectors/topic-map-participants-after/ai-conversation-invite.gjs";
compatModules["discourse/connectors/topic-map-participants-after/ai-conversation-invite"] = Mod119;

export * as discourse$connectors$topic__map__participants__after$ai__conversation__invite$$__module from "./discourse/connectors/topic-map-participants-after/ai-conversation-invite.gjs";
export {
default as discourse$connectors$topic__map__participants__after$ai__conversation__invite$$default
} from "./discourse/connectors/topic-map-participants-after/ai-conversation-invite.gjs";
import * as Mod120 from "./discourse/connectors/user-messages-controls-bottom/pm-list-gist-toggle.gjs";
compatModules["discourse/connectors/user-messages-controls-bottom/pm-list-gist-toggle"] = Mod120;

export * as discourse$connectors$user__messages__controls__bottom$pm__list__gist__toggle$$__module from "./discourse/connectors/user-messages-controls-bottom/pm-list-gist-toggle.gjs";
export {
default as discourse$connectors$user__messages__controls__bottom$pm__list__gist__toggle$$default
} from "./discourse/connectors/user-messages-controls-bottom/pm-list-gist-toggle.gjs";
import * as Mod121 from "./discourse/connectors/user-preferences-interface/ai-search-discoveries.gjs";
compatModules["discourse/connectors/user-preferences-interface/ai-search-discoveries"] = Mod121;

export * as discourse$connectors$user__preferences__interface$ai__search__discoveries$$__module from "./discourse/connectors/user-preferences-interface/ai-search-discoveries.gjs";
export {
default as discourse$connectors$user__preferences__interface$ai__search__discoveries$$default
} from "./discourse/connectors/user-preferences-interface/ai-search-discoveries.gjs";
import * as Mod122 from "./discourse/controllers/discourse-ai-bot-conversations";
compatModules["discourse/controllers/discourse-ai-bot-conversations"] = Mod122;

export * as discourse$controllers$discourse__ai__bot__conversations$$__module from "./discourse/controllers/discourse-ai-bot-conversations";
export {
default as discourse$controllers$discourse__ai__bot__conversations$$default
} from "./discourse/controllers/discourse-ai-bot-conversations";
import * as Mod123 from "./discourse/discourse-ai-bot-dashboard-route-map";
compatModules["discourse/discourse-ai-bot-dashboard-route-map"] = Mod123;

export * as discourse$discourse__ai__bot__dashboard__route__map$$__module from "./discourse/discourse-ai-bot-dashboard-route-map";
export {
default as discourse$discourse__ai__bot__dashboard__route__map$$default
} from "./discourse/discourse-ai-bot-dashboard-route-map";
import * as Mod124 from "./discourse/discourse-ai-shared-conversation-show-route-map";
compatModules["discourse/discourse-ai-shared-conversation-show-route-map"] = Mod124;

export * as discourse$discourse__ai__shared__conversation__show__route__map$$__module from "./discourse/discourse-ai-shared-conversation-show-route-map";
export {
default as discourse$discourse__ai__shared__conversation__show__route__map$$default
} from "./discourse/discourse-ai-shared-conversation-show-route-map";
import * as Mod125 from "./discourse/initializers/add-ai-bot-to-community-section";
compatModules["discourse/initializers/add-ai-bot-to-community-section"] = Mod125;

export * as discourse$initializers$add__ai__bot__to__community__section$$__module from "./discourse/initializers/add-ai-bot-to-community-section";
export {
default as discourse$initializers$add__ai__bot__to__community__section$$default
} from "./discourse/initializers/add-ai-bot-to-community-section";
import * as Mod126 from "./discourse/initializers/admin-plugin-configuration-nav";
compatModules["discourse/initializers/admin-plugin-configuration-nav"] = Mod126;

export * as discourse$initializers$admin__plugin__configuration__nav$$__module from "./discourse/initializers/admin-plugin-configuration-nav";
export {
default as discourse$initializers$admin__plugin__configuration__nav$$default
} from "./discourse/initializers/admin-plugin-configuration-nav";
import * as Mod127 from "./discourse/initializers/ai-artifacts";
compatModules["discourse/initializers/ai-artifacts"] = Mod127;

export * as discourse$initializers$ai__artifacts$$__module from "./discourse/initializers/ai-artifacts";
export {
default as discourse$initializers$ai__artifacts$$default
} from "./discourse/initializers/ai-artifacts";
import * as Mod128 from "./discourse/initializers/ai-bot-pm";
compatModules["discourse/initializers/ai-bot-pm"] = Mod128;

export * as discourse$initializers$ai__bot__pm$$__module from "./discourse/initializers/ai-bot-pm";
export {
default as discourse$initializers$ai__bot__pm$$default
} from "./discourse/initializers/ai-bot-pm";
import * as Mod129 from "./discourse/initializers/ai-bot-replies";
compatModules["discourse/initializers/ai-bot-replies"] = Mod129;

export * as discourse$initializers$ai__bot__replies$$__module from "./discourse/initializers/ai-bot-replies";
export {
default as discourse$initializers$ai__bot__replies$$default
} from "./discourse/initializers/ai-bot-replies";
import * as Mod130 from "./discourse/initializers/ai-category-chooser-inline-suggester";
compatModules["discourse/initializers/ai-category-chooser-inline-suggester"] = Mod130;

export * as discourse$initializers$ai__category__chooser__inline__suggester$$__module from "./discourse/initializers/ai-category-chooser-inline-suggester";
export {
default as discourse$initializers$ai__category__chooser__inline__suggester$$default
} from "./discourse/initializers/ai-category-chooser-inline-suggester";
import * as Mod131 from "./discourse/initializers/ai-chat-summarization";
compatModules["discourse/initializers/ai-chat-summarization"] = Mod131;

export * as discourse$initializers$ai__chat__summarization$$__module from "./discourse/initializers/ai-chat-summarization";
export {
default as discourse$initializers$ai__chat__summarization$$default
} from "./discourse/initializers/ai-chat-summarization";
import * as Mod132 from "./discourse/initializers/ai-conversations-sidebar";
compatModules["discourse/initializers/ai-conversations-sidebar"] = Mod132;

export * as discourse$initializers$ai__conversations__sidebar$$__module from "./discourse/initializers/ai-conversations-sidebar";
export {
default as discourse$initializers$ai__conversations__sidebar$$default
} from "./discourse/initializers/ai-conversations-sidebar";
import * as Mod133 from "./discourse/initializers/ai-gist-connector";
compatModules["discourse/initializers/ai-gist-connector"] = Mod133;

export * as discourse$initializers$ai__gist__connector$$__module from "./discourse/initializers/ai-gist-connector";
export {
default as discourse$initializers$ai__gist__connector$$default
} from "./discourse/initializers/ai-gist-connector";
import * as Mod134 from "./discourse/initializers/ai-gist-topic-list-class";
compatModules["discourse/initializers/ai-gist-topic-list-class"] = Mod134;

export * as discourse$initializers$ai__gist__topic__list__class$$__module from "./discourse/initializers/ai-gist-topic-list-class";
export {
default as discourse$initializers$ai__gist__topic__list__class$$default
} from "./discourse/initializers/ai-gist-topic-list-class";
import * as Mod135 from "./discourse/initializers/ai-helper";
compatModules["discourse/initializers/ai-helper"] = Mod135;

export * as discourse$initializers$ai__helper$$__module from "./discourse/initializers/ai-helper";
export {
default as discourse$initializers$ai__helper$$default
} from "./discourse/initializers/ai-helper";
import * as Mod136 from "./discourse/initializers/ai-image-caption";
compatModules["discourse/initializers/ai-image-caption"] = Mod136;

export * as discourse$initializers$ai__image__caption$$__module from "./discourse/initializers/ai-image-caption";
export {
default as discourse$initializers$ai__image__caption$$default
} from "./discourse/initializers/ai-image-caption";
import * as Mod137 from "./discourse/initializers/ai-reviewable-status";
compatModules["discourse/initializers/ai-reviewable-status"] = Mod137;

export * as discourse$initializers$ai__reviewable__status$$__module from "./discourse/initializers/ai-reviewable-status";
export {
default as discourse$initializers$ai__reviewable__status$$default
} from "./discourse/initializers/ai-reviewable-status";
import * as Mod138 from "./discourse/initializers/ai-search-discoveries";
compatModules["discourse/initializers/ai-search-discoveries"] = Mod138;

export * as discourse$initializers$ai__search__discoveries$$__module from "./discourse/initializers/ai-search-discoveries";
export {
default as discourse$initializers$ai__search__discoveries$$default
} from "./discourse/initializers/ai-search-discoveries";
import * as Mod139 from "./discourse/initializers/ai-semantic-search";
compatModules["discourse/initializers/ai-semantic-search"] = Mod139;

export * as discourse$initializers$ai__semantic__search$$__module from "./discourse/initializers/ai-semantic-search";
export {
default as discourse$initializers$ai__semantic__search$$default
} from "./discourse/initializers/ai-semantic-search";
import * as Mod140 from "./discourse/initializers/ai-sentiment-admin-nav";
compatModules["discourse/initializers/ai-sentiment-admin-nav"] = Mod140;

export * as discourse$initializers$ai__sentiment__admin__nav$$__module from "./discourse/initializers/ai-sentiment-admin-nav";
export {
default as discourse$initializers$ai__sentiment__admin__nav$$default
} from "./discourse/initializers/ai-sentiment-admin-nav";
import * as Mod141 from "./discourse/initializers/ai-tag-chooser-inline-suggester";
compatModules["discourse/initializers/ai-tag-chooser-inline-suggester"] = Mod141;

export * as discourse$initializers$ai__tag__chooser__inline__suggester$$__module from "./discourse/initializers/ai-tag-chooser-inline-suggester";
export {
default as discourse$initializers$ai__tag__chooser__inline__suggester$$default
} from "./discourse/initializers/ai-tag-chooser-inline-suggester";
import * as Mod142 from "./discourse/initializers/ai-translation-topic-admin";
compatModules["discourse/initializers/ai-translation-topic-admin"] = Mod142;

export * as discourse$initializers$ai__translation__topic__admin$$__module from "./discourse/initializers/ai-translation-topic-admin";
export {
default as discourse$initializers$ai__translation__topic__admin$$default
} from "./discourse/initializers/ai-translation-topic-admin";
import * as Mod143 from "./discourse/initializers/related-topics";
compatModules["discourse/initializers/related-topics"] = Mod143;

export * as discourse$initializers$related__topics$$__module from "./discourse/initializers/related-topics";
export {
default as discourse$initializers$related__topics$$default
} from "./discourse/initializers/related-topics";
import * as Mod144 from "./discourse/initializers/translation";
compatModules["discourse/initializers/translation"] = Mod144;

export * as discourse$initializers$translation$$__module from "./discourse/initializers/translation";
export {
default as discourse$initializers$translation$$default
} from "./discourse/initializers/translation";
import * as Mod145 from "./discourse/lib/ai-bot-helper";
compatModules["discourse/lib/ai-bot-helper"] = Mod145;

export * as discourse$lib$ai__bot__helper$$__module from "./discourse/lib/ai-bot-helper";
export {
isGPTBot as discourse$lib$ai__bot__helper$$isGPTBot,
getBotType as discourse$lib$ai__bot__helper$$getBotType,
isPostFromAiBot as discourse$lib$ai__bot__helper$$isPostFromAiBot,
showShareConversationModal as discourse$lib$ai__bot__helper$$showShareConversationModal
} from "./discourse/lib/ai-bot-helper";
import * as Mod146 from "./discourse/lib/ai-errors";
compatModules["discourse/lib/ai-errors"] = Mod146;

export * as discourse$lib$ai__errors$$__module from "./discourse/lib/ai-errors";
export {
isAiCreditLimitError as discourse$lib$ai__errors$$isAiCreditLimitError,
getAiCreditLimitMessage as discourse$lib$ai__errors$$getAiCreditLimitMessage,
popupAiCreditLimitError as discourse$lib$ai__errors$$popupAiCreditLimitError
} from "./discourse/lib/ai-errors";
import * as Mod147 from "./discourse/lib/ai-feature-setting-groups";
compatModules["discourse/lib/ai-feature-setting-groups"] = Mod147;

export * as discourse$lib$ai__feature__setting__groups$$__module from "./discourse/lib/ai-feature-setting-groups";
export {
AI_FEATURE_SETTING_GROUPS as discourse$lib$ai__feature__setting__groups$$AI_FEATURE_SETTING_GROUPS,
getSettingGroupsForFeature as discourse$lib$ai__feature__setting__groups$$getSettingGroupsForFeature
} from "./discourse/lib/ai-feature-setting-groups";
import * as Mod148 from "./discourse/lib/ai-helper-suggestions";
compatModules["discourse/lib/ai-helper-suggestions"] = Mod148;

export * as discourse$lib$ai__helper__suggestions$$__module from "./discourse/lib/ai-helper-suggestions";
export {
MIN_CHARACTER_COUNT as discourse$lib$ai__helper__suggestions$$MIN_CHARACTER_COUNT,
tagSuggestionParams as discourse$lib$ai__helper__suggestions$$tagSuggestionParams,
showSuggestionsError as discourse$lib$ai__helper__suggestions$$showSuggestionsError
} from "./discourse/lib/ai-helper-suggestions";
import * as Mod149 from "./discourse/lib/ai-streamer/progress-handlers";
compatModules["discourse/lib/ai-streamer/progress-handlers"] = Mod149;

export * as discourse$lib$ai__streamer$progress__handlers$$__module from "./discourse/lib/ai-streamer/progress-handlers";
export {
MIN_LETTERS_PER_INTERVAL as discourse$lib$ai__streamer$progress__handlers$$MIN_LETTERS_PER_INTERVAL,
addProgressDecoration as discourse$lib$ai__streamer$progress__handlers$$addProgressDecoration,
applyProgress as discourse$lib$ai__streamer$progress__handlers$$applyProgress,
streamPostText as discourse$lib$ai__streamer$progress__handlers$$streamPostText,
cleanupStreamingData as discourse$lib$ai__streamer$progress__handlers$$cleanupStreamingData,
default as discourse$lib$ai__streamer$progress__handlers$$default
} from "./discourse/lib/ai-streamer/progress-handlers";
import * as Mod150 from "./discourse/lib/ai-streamer/updaters/post-updater";
compatModules["discourse/lib/ai-streamer/updaters/post-updater"] = Mod150;

export * as discourse$lib$ai__streamer$updaters$post__updater$$__module from "./discourse/lib/ai-streamer/updaters/post-updater";
export {
default as discourse$lib$ai__streamer$updaters$post__updater$$default
} from "./discourse/lib/ai-streamer/updaters/post-updater";
import * as Mod151 from "./discourse/lib/ai-streamer/updaters/stream-updater";
compatModules["discourse/lib/ai-streamer/updaters/stream-updater"] = Mod151;

export * as discourse$lib$ai__streamer$updaters$stream__updater$$__module from "./discourse/lib/ai-streamer/updaters/stream-updater";
export {
default as discourse$lib$ai__streamer$updaters$stream__updater$$default
} from "./discourse/lib/ai-streamer/updaters/stream-updater";
import * as Mod152 from "./discourse/lib/ai-topic-summary";
compatModules["discourse/lib/ai-topic-summary"] = Mod152;

export * as discourse$lib$ai__topic__summary$$__module from "./discourse/lib/ai-topic-summary";
export {
default as discourse$lib$ai__topic__summary$$default
} from "./discourse/lib/ai-topic-summary";
import * as Mod153 from "./discourse/lib/ai-usage-time-series";
compatModules["discourse/lib/ai-usage-time-series"] = Mod153;

export * as discourse$lib$ai__usage__time__series$$__module from "./discourse/lib/ai-usage-time-series";
export {
normalizeAiUsageTimeSeriesData as discourse$lib$ai__usage__time__series$$normalizeAiUsageTimeSeriesData
} from "./discourse/lib/ai-usage-time-series";
import * as Mod154 from "./discourse/lib/copy-conversation";
compatModules["discourse/lib/copy-conversation"] = Mod154;

export * as discourse$lib$copy__conversation$$__module from "./discourse/lib/copy-conversation";
export {
default as discourse$lib$copy__conversation$$default
} from "./discourse/lib/copy-conversation";
import * as Mod155 from "./discourse/lib/diff-streamer";
compatModules["discourse/lib/diff-streamer"] = Mod155;

export * as discourse$lib$diff__streamer$$__module from "./discourse/lib/diff-streamer";
export {
default as discourse$lib$diff__streamer$$default
} from "./discourse/lib/diff-streamer";
import * as Mod156 from "./discourse/lib/llm-provider-param-helpers";
compatModules["discourse/lib/llm-provider-param-helpers"] = Mod156;

export * as discourse$lib$llm__provider__param__helpers$$__module from "./discourse/lib/llm-provider-param-helpers";
export {
isParamActive as discourse$lib$llm__provider__param__helpers$$isParamActive,
isProviderParamHidden as discourse$lib$llm__provider__param__helpers$$isProviderParamHidden,
normalizeProviderParams as discourse$lib$llm__provider__param__helpers$$normalizeProviderParams
} from "./discourse/lib/llm-provider-param-helpers";
import * as Mod157 from "./discourse/lib/search-discoveries-context";
compatModules["discourse/lib/search-discoveries-context"] = Mod157;

export * as discourse$lib$search__discoveries__context$$__module from "./discourse/lib/search-discoveries-context";
export {
isScopedSearch as discourse$lib$search__discoveries__context$$isScopedSearch
} from "./discourse/lib/search-discoveries-context";
import * as Mod158 from "./discourse/lib/show-ai-helper";
compatModules["discourse/lib/show-ai-helper"] = Mod158;

export * as discourse$lib$show__ai__helper$$__module from "./discourse/lib/show-ai-helper";
export {
showComposerAiHelper as discourse$lib$show__ai__helper$$showComposerAiHelper,
showPostAIHelper as discourse$lib$show__ai__helper$$showPostAIHelper
} from "./discourse/lib/show-ai-helper";
import * as Mod159 from "./discourse/lib/smooth-streamer";
compatModules["discourse/lib/smooth-streamer"] = Mod159;

export * as discourse$lib$smooth__streamer$$__module from "./discourse/lib/smooth-streamer";
export {
default as discourse$lib$smooth__streamer$$default
} from "./discourse/lib/smooth-streamer";
import * as Mod160 from "./discourse/lib/utilities";
compatModules["discourse/lib/utilities"] = Mod160;

export * as discourse$lib$utilities$$__module from "./discourse/lib/utilities";
export {
toPlainObject as discourse$lib$utilities$$toPlainObject,
jsonToHtml as discourse$lib$utilities$$jsonToHtml
} from "./discourse/lib/utilities";
import * as Mod161 from "./discourse/pre-initializers/ai-spam-transformers";
compatModules["discourse/pre-initializers/ai-spam-transformers"] = Mod161;

export * as discourse$pre__initializers$ai__spam__transformers$$__module from "./discourse/pre-initializers/ai-spam-transformers";
export {
default as discourse$pre__initializers$ai__spam__transformers$$default
} from "./discourse/pre-initializers/ai-spam-transformers";
import * as Mod162 from "./discourse/routes/discourse-ai-bot-conversations";
compatModules["discourse/routes/discourse-ai-bot-conversations"] = Mod162;

export * as discourse$routes$discourse__ai__bot__conversations$$__module from "./discourse/routes/discourse-ai-bot-conversations";
export {
default as discourse$routes$discourse__ai__bot__conversations$$default
} from "./discourse/routes/discourse-ai-bot-conversations";
import * as Mod163 from "./discourse/routes/discourse-ai-shared-conversation-show";
compatModules["discourse/routes/discourse-ai-shared-conversation-show"] = Mod163;

export * as discourse$routes$discourse__ai__shared__conversation__show$$__module from "./discourse/routes/discourse-ai-shared-conversation-show";
export {
default as discourse$routes$discourse__ai__shared__conversation__show$$default
} from "./discourse/routes/discourse-ai-shared-conversation-show";
import * as Mod164 from "./discourse/services/ai-bot-conversations-hidden-submit";
compatModules["discourse/services/ai-bot-conversations-hidden-submit"] = Mod164;

export * as discourse$services$ai__bot__conversations__hidden__submit$$__module from "./discourse/services/ai-bot-conversations-hidden-submit";
export {
default as discourse$services$ai__bot__conversations__hidden__submit$$default
} from "./discourse/services/ai-bot-conversations-hidden-submit";
import * as Mod165 from "./discourse/services/ai-bot-docked-submit";
compatModules["discourse/services/ai-bot-docked-submit"] = Mod165;

export * as discourse$services$ai__bot__docked__submit$$__module from "./discourse/services/ai-bot-docked-submit";
export {
default as discourse$services$ai__bot__docked__submit$$default
} from "./discourse/services/ai-bot-docked-submit";
import * as Mod166 from "./discourse/services/ai-bot-streaming-state";
compatModules["discourse/services/ai-bot-streaming-state"] = Mod166;

export * as discourse$services$ai__bot__streaming__state$$__module from "./discourse/services/ai-bot-streaming-state";
export {
default as discourse$services$ai__bot__streaming__state$$default
} from "./discourse/services/ai-bot-streaming-state";
import * as Mod167 from "./discourse/services/ai-conversations-sidebar-manager";
compatModules["discourse/services/ai-conversations-sidebar-manager"] = Mod167;

export * as discourse$services$ai__conversations__sidebar__manager$$__module from "./discourse/services/ai-conversations-sidebar-manager";
export {
AI_CONVERSATIONS_PANEL as discourse$services$ai__conversations__sidebar__manager$$AI_CONVERSATIONS_PANEL,
default as discourse$services$ai__conversations__sidebar__manager$$default
} from "./discourse/services/ai-conversations-sidebar-manager";
import * as Mod168 from "./discourse/services/ai-credits";
compatModules["discourse/services/ai-credits"] = Mod168;

export * as discourse$services$ai__credits$$__module from "./discourse/services/ai-credits";
export {
default as discourse$services$ai__credits$$default
} from "./discourse/services/ai-credits";
import * as Mod169 from "./discourse/services/discobot-discoveries";
compatModules["discourse/services/discobot-discoveries"] = Mod169;

export * as discourse$services$discobot__discoveries$$__module from "./discourse/services/discobot-discoveries";
export {
default as discourse$services$discobot__discoveries$$default
} from "./discourse/services/discobot-discoveries";
import * as Mod170 from "./discourse/services/gists";
compatModules["discourse/services/gists"] = Mod170;

export * as discourse$services$gists$$__module from "./discourse/services/gists";
export {
TABLE_LAYOUT as discourse$services$gists$$TABLE_LAYOUT,
TABLE_AI_LAYOUT as discourse$services$gists$$TABLE_AI_LAYOUT,
default as discourse$services$gists$$default
} from "./discourse/services/gists";
import * as Mod171 from "./discourse/services/image-caption-popup";
compatModules["discourse/services/image-caption-popup"] = Mod171;

export * as discourse$services$image__caption__popup$$__module from "./discourse/services/image-caption-popup";
export {
default as discourse$services$image__caption__popup$$default
} from "./discourse/services/image-caption-popup";
import * as Mod172 from "./discourse/services/quick-search";
compatModules["discourse/services/quick-search"] = Mod172;

export * as discourse$services$quick__search$$__module from "./discourse/services/quick-search";
export {
default as discourse$services$quick__search$$default
} from "./discourse/services/quick-search";
import * as Mod173 from "./discourse/templates/discourse-ai-bot-conversations";
compatModules["discourse/templates/discourse-ai-bot-conversations"] = Mod173;

export * as discourse$templates$discourse__ai__bot__conversations$$__module from "./discourse/templates/discourse-ai-bot-conversations";
export {
default as discourse$templates$discourse__ai__bot__conversations$$default
} from "./discourse/templates/discourse-ai-bot-conversations";
import * as Mod174 from "./lib/discourse-markdown/ai-tags";
compatModules["lib/discourse-markdown/ai-tags"] = Mod174;

export * as lib$discourse__markdown$ai__tags$$__module from "./lib/discourse-markdown/ai-tags";
export {
setup as lib$discourse__markdown$ai__tags$$setup
} from "./lib/discourse-markdown/ai-tags";
export default compatModules;
